import { render, staticRenderFns } from "./ProdEditAbout.vue?vue&type=template&id=7ab12e6f&scoped=true&"
import script from "./ProdEditAbout.vue?vue&type=script&lang=js&"
export * from "./ProdEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab12e6f",
  null
  
)

export default component.exports